import React, {memo} from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {Link, Text, Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import CloudinaryImage from '../../../../cloudinary-media/image'

const CategoryTile = ({url, ...rest}) => {
    const imageProps = {
        background: 'gray.100',
        widths: '100%',
        imageProps: {
            alt: '',
            loading: 'eager',
            height: 'auto',
            aspectRatio: '25/32',
            mixBlendMode: 'multiply',
            width: {
                base: rest.isGrid ? '42px' : '77px',
                sm: rest.isGrid ? '75px' : '77px',
                md: '100px'
            }
        }
    }

    return (
        <Box>
            <Link
                position="relative"
                textDecoration="none"
                _hover={{textDecoration: 'none'}}
                {...(/^(https?:)?\/\//i.test(url) || url.includes('.html')
                    ? {href: url}
                    : {as: RouteLink, to: url})}
            >
                <Box
                    background={rest.backgroundColor || 'white'}
                    display="flex"
                    justifyContent="center"
                >
                    <CloudinaryImage
                        src={rest.image}
                        alt={rest.alt || rest.title || ''}
                        styles={imageProps.imageProps}
                        imgSizes={{
                            base: rest.isGrid ? '42px' : '77px',
                            sm: rest.isGrid ? '75px' : '77px',
                            md: '100px'
                        }}
                    />
                </Box>
                <Text
                    overflow="hidden"
                    textOverflow="ellipsis"
                    fontSize={rest.isGrid ? '11px' : '15px'}
                    fontFamily={rest.textFontFamily || 'caslon'}
                    color={rest.textColor || 'black.100'}
                    whiteSpace="nowrap"
                    fontWeight="300"
                    textAlign={rest.textAlignment || 'center'}
                    marginTop="4px"
                >
                    {rest.title}
                </Text>
            </Link>
        </Box>
    )
}

CategoryTile.propTypes = {
    url: PropTypes.string.isRequired,
    image: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    textColor: PropTypes.string,
    textFontFamily: PropTypes.string,
    backgroundColor: PropTypes.string,
    textAlignment: PropTypes.string,
    isGrid: PropTypes.bool
}

export default memo(CategoryTile)
